import { arrayOf, Schema } from 'normalizr';

import { type GraphQLSchema } from './types';

const listener = new Schema('listeners', { idAttribute: 'pandoraId' });
const playlist = new Schema('playlists', { idAttribute: 'pandoraId' });
const album = new Schema('albums', { idAttribute: 'pandoraId' });
const albumSlug = new Schema('albums', { idAttribute: 'name' });
const albumUrl = new Schema('albums', { idAttribute: 'shareableUrlPath' });
const track = new Schema('tracks', { idAttribute: 'pandoraId' });
const artist = new Schema('artists', { idAttribute: 'pandoraId' });
const artistSlug = new Schema('artists', { idAttribute: 'name' });
const artistPlay = new Schema('artistsPlay', { idAttribute: 'pandoraId' });
const artistTrackPlay = new Schema('artistTracksPlay', {
  idAttribute: 'pandoraId',
});
const stationFactory = new Schema('stationFactories', {
  idAttribute: 'pandoraId',
});
const seed = new Schema('seeds', { idAttribute: 'pandoraId' });
const seedPandoraType = new Schema('seedPandoraTypes', { idAttribute: 'type' });
const podcast = new Schema('podcasts', { idAttribute: 'pandoraId' });
const podcastSlug = new Schema('podcasts', { idAttribute: 'name' });
const podcastEpisodeElapsedTime = new Schema('elapsedTimes', {
  idAttribute: 'elapsedTime',
});
const annotation = new Schema('annotations', { idAttribute: 'pandoraId' });
const detail = new Schema('details', { idAttribute: 'pandoraId' });

track.define({
  artistId: artist,
  artistName: artistSlug,
  albumId: album,
  albumName: albumSlug,
});

album.define({
  artistId: artist,
  artistName: artistSlug,
  tracks: arrayOf(track),
});

playlist.define({
  listenerPandoraId: listener,
});

stationFactory.define({
  seedId: seed,
  seedType: seedPandoraType,
});

annotation.define({
  artistId: artist,
  artistName: artistSlug,
  albumId: album,
  albumName: albumSlug,
  albumShareableUrlPath: albumUrl,
  seedId: seed,
  seedType: seedPandoraType,
  podcastId: podcast,
  programName: podcastSlug,
  elapsedTime: podcastEpisodeElapsedTime,
  tracks: arrayOf(track),
  listenerPandoraId: listener,
});

detail.define({
  featuredBy: arrayOf(annotation),
  topAlbums: arrayOf(annotation),
  topTracks: arrayOf(annotation),
  collaborationArtists: arrayOf(annotation),
  similarArtists: arrayOf(annotation),
  latestRelease: annotation,
  stationFactoryId: stationFactory,
  artistPlayId: artistPlay,
  artistTracksId: artistTrackPlay,
});

const details: GraphQLSchema = {
  data: {
    entity: detail,
  },
};

const annotations: GraphQLSchema = {
  data: {
    entities: arrayOf(annotation),
  },
};

// when selected, normalization is performed but is not outputted
const noEntity: GraphQLSchema = {
  data: {
    noEntity: new Schema('noEntity'),
  },
};

export default Object.freeze({
  GET_DETAILS: details,
  GET_ANNOTATIONS: annotations,
  NO_ENTITY: noEntity,
} as const);
